export default "__VITE_ASSET__CAwVsAit__";